import { TrainingCourse } from '../types/trainingCourse'

export const trainingCourses: TrainingCourse[] = [
  {
    id: 'crs-001',
    name: 'Formazione generale lavoratori — Sessione ottobre',
    productCode: 'FOR-FGL',
    courseCode: 'FGL-2026-10',
    externalProduct: false,
    characteristic: 'Trainante',
    commission: 'SEFORM',
    venue: 'seform',
    status: 'attivi',
    startDate: '2026-09-21',
    endDate: '2026-10-02',
    teachers: [
      { teacherId: 't-01', assignmentStatus: 'Confermato', hourlyRate: 45, hours: 4 },
    ],
    otherCostsAmount: 60,
  },
  {
    id: 'crs-002',
    name: 'Specifica rischio basso — Sessione ottobre',
    productCode: 'FOR-FSB',
    courseCode: 'FSB-2026-10',
    externalProduct: false,
    characteristic: 'Trainato',
    leadCourseId: 'crs-001',
    commission: 'SEFORM',
    venue: 'seform',
    status: 'attivi',
    startDate: '2026-09-28',
    endDate: '2026-10-02',
    teachers: [
      { teacherId: 't-10', assignmentStatus: 'Confermato', hourlyRate: 44, hours: 4 },
    ],
  },
  {
    id: 'crs-003',
    name: 'Specifica rischio medio — Sessione ottobre',
    productCode: 'FOR-FSM',
    courseCode: 'FSM-2026-10',
    externalProduct: false,
    characteristic: 'Trainato',
    leadCourseId: 'crs-001',
    commission: 'SEFORM',
    venue: 'seform',
    status: 'attivi',
    startDate: '2026-09-28',
    endDate: '2026-10-09',
    teachers: [
      { teacherId: 't-01', assignmentStatus: 'Inviato', hourlyRate: 45, hours: 8 },
    ],
    equipmentType: 'Videoproiettore',
    equipmentAmount: 80,
  },
  {
    id: 'crs-004',
    name: 'Preposto — Azienda 0 SRL',
    productCode: 'FOR-PRE',
    courseCode: 'PRE-A0-01',
    externalProduct: false,
    characteristic: 'Unico',
    commission: 'Cliente',
    clientName: 'Azienda 0 SRL',
    venue: 'cliente',
    clientSite: 'Sede legale — Via Roma 10, Arezzo',
    status: 'attivi',
    startDate: '2026-10-05',
    endDate: '2026-10-06',
    teachers: [
      { teacherId: 't-01', assignmentStatus: 'Confermato', hourlyRate: 45, hours: 8 },
    ],
    otherCostsAmount: 40,
  },
  {
    id: 'crs-005',
    name: 'Primo soccorso gruppo B/C',
    productCode: 'FOR-PSB',
    courseCode: 'PSB-2026-09',
    externalProduct: true,
    characteristic: 'Unico',
    commission: 'SEFORM',
    venue: 'blended',
    status: 'attivi',
    startDate: '2026-09-15',
    endDate: '2026-09-30',
    teachers: [
      { teacherId: 't-02', assignmentStatus: 'Confermato', hourlyRate: 50, hours: 12 },
    ],
    equipmentType: 'Manichino RCP',
    equipmentAmount: 150,
    externalCostAmount: 320,
    externalSupplier: 'Croce Verde Formazione',
  },
  {
    id: 'crs-006',
    name: 'Antincendio livello 2 — Impresa 2 SPA',
    productCode: 'FOR-AI2',
    courseCode: 'AI2-I2-01',
    externalProduct: false,
    characteristic: 'Unico',
    commission: 'Cliente',
    clientName: 'Impresa 2 SPA',
    venue: 'cliente',
    clientSite: 'Sede operativa — Zona industriale 12, Firenze',
    status: 'attivi',
    startDate: '2026-10-12',
    endDate: '2026-10-12',
    teachers: [
      { teacherId: 't-02', assignmentStatus: 'Inviato', hourlyRate: 50, hours: 5 },
      { teacherId: 't-06', assignmentStatus: 'Da inviare', hourlyRate: 52, hours: 3 },
    ],
    equipmentType: 'Estintori da addestramento',
    equipmentAmount: 200,
  },
  {
    id: 'crs-007',
    name: 'Formazione generale lavoratori — Sessione novembre',
    productCode: 'FOR-FGL',
    courseCode: 'FGL-2026-11',
    externalProduct: false,
    characteristic: 'Trainante',
    commission: 'SEFORM',
    venue: 'fad',
    status: 'programma',
    startDate: '2026-11-09',
    endDate: '2026-11-13',
    teachers: [
      { teacherId: 't-05', assignmentStatus: 'Da inviare', hourlyRate: 40, hours: 4 },
    ],
  },
  {
    id: 'crs-008',
    name: 'Specifica rischio alto — Sessione novembre',
    productCode: 'FOR-FSA',
    courseCode: 'FSA-2026-11',
    externalProduct: false,
    characteristic: 'Trainato',
    leadCourseId: 'crs-007',
    commission: 'SEFORM',
    venue: 'seform',
    status: 'programma',
    startDate: '2026-11-16',
    endDate: '2026-11-27',
    teachers: [
      { teacherId: 't-01', assignmentStatus: 'Da inviare', hourlyRate: 45, hours: 6 },
      { teacherId: 't-07', assignmentStatus: 'Da inviare', hourlyRate: 58, hours: 6 },
    ],
    roomRentalAmount: 350,
  },
  {
    id: 'crs-009',
    name: 'Carrellisti — Studio 1 Associati',
    productCode: 'FOR-CAR',
    courseCode: 'CAR-S1-01',
    externalProduct: true,
    characteristic: 'Unico',
    commission: 'Cliente',
    clientName: 'Studio 1 Associati',
    venue: 'cliente',
    clientSite: 'Sede legale — Via Roma 11, Siena',
    status: 'programma',
    startDate: '2026-11-18',
    endDate: '2026-11-19',
    teachers: [
      { teacherId: 't-03', assignmentStatus: 'Inviato', hourlyRate: 55, hours: 12 },
    ],
    equipmentType: 'Carrello elevatore',
    equipmentAmount: 400,
    externalCostAmount: 280,
    externalSupplier: 'Forklift Academy Srl',
  },
  {
    id: 'crs-010',
    name: 'RSPP datore di lavoro — Modulo 1',
    productCode: 'FOR-RDL',
    courseCode: 'RDL-2026-12',
    externalProduct: false,
    characteristic: 'Unico',
    commission: 'SEFORM',
    venue: 'blended',
    status: 'programma',
    startDate: '2026-12-01',
    endDate: '2026-12-15',
    teachers: [
      { teacherId: 't-04', assignmentStatus: 'Da inviare', hourlyRate: 60, hours: 8 },
      { teacherId: 't-09', assignmentStatus: 'Inviato', hourlyRate: 65, hours: 8 },
    ],
    roomRentalAmount: 500,
  },
  {
    id: 'crs-011',
    name: 'Aggiornamento RLS 2025',
    productCode: 'FOR-ARL',
    courseCode: 'ARL-2025-06',
    externalProduct: false,
    characteristic: 'Unico',
    commission: 'SEFORM',
    venue: 'seform',
    status: 'archivio',
    startDate: '2025-06-10',
    endDate: '2025-06-10',
    teachers: [
      { teacherId: 't-04', assignmentStatus: 'Confermato', hourlyRate: 60, hours: 4 },
    ],
  },
  {
    id: 'crs-012',
    name: 'PLE — Azienda 3 SRL',
    productCode: 'FOR-PLE',
    courseCode: 'PLE-A3-01',
    externalProduct: true,
    characteristic: 'Unico',
    commission: 'Cliente',
    clientName: 'Azienda 3 SRL',
    venue: 'cliente',
    clientSite: 'Sede legale — Via Roma 13, Perugia',
    status: 'archivio',
    startDate: '2025-09-22',
    endDate: '2025-09-23',
    teachers: [
      { teacherId: 't-03', assignmentStatus: 'Confermato', hourlyRate: 55, hours: 10 },
    ],
    equipmentType: 'Piattaforma aerea PLE',
    equipmentAmount: 450,
    externalCostAmount: 350,
    externalSupplier: 'Forklift Academy Srl',
  },
  {
    id: 'crs-013',
    name: 'Formazione generale lavoratori — On-demand',
    productCode: 'FOR-FGL',
    courseCode: 'FGL-OD',
    externalProduct: false,
    characteristic: 'Unico',
    status: 'ondemand',
    teachers: [],
    productionCost: 160,
    enrollments: [
      { id: 'enr-001', firstName: 'Matteo', lastName: 'Ferri', email: 'matteo.ferri@gmail.com', enrolledAt: '2026-08-04', price: 49, credentialsSentAt: '2026-08-04T10:12:00', completed: true, certificateSentAt: '2026-08-20T09:30:00' },
      { id: 'enr-002', firstName: 'Laura', lastName: 'Bassi', email: 'laura.bassi@libero.it', enrolledAt: '2026-08-19', price: 49, credentialsSentAt: '2026-08-19T15:40:00', completed: true },
      { id: 'enr-003', firstName: 'Simone', lastName: 'Gatti', email: 's.gatti@outlook.it', enrolledAt: '2026-09-02', price: 49, credentialsSentAt: '2026-09-02T11:05:00', completed: false },
      { id: 'enr-004', firstName: 'Valentina', lastName: 'Russo', email: 'vale.russo@gmail.com', enrolledAt: '2026-09-24', price: 49, completed: false },
      { id: 'enr-005', firstName: 'Paolo', lastName: 'Conti', email: 'paolo.conti@email.it', enrolledAt: '2026-09-29', price: 49, completed: false },
    ],
  },
  {
    id: 'crs-014',
    name: 'HACCP alimentaristi — On-demand',
    productCode: 'FOR-HAC',
    courseCode: 'HAC-OD',
    externalProduct: true,
    characteristic: 'Unico',
    status: 'ondemand',
    teachers: [],
    productionCost: 168,
    externalCostAmount: 180,
    externalSupplier: 'Alimenta Learning',
    enrollments: [
      { id: 'enr-101', firstName: 'Sofia', lastName: 'Marini', email: 'sofia.marini@gmail.com', enrolledAt: '2026-07-15', price: 59, credentialsSentAt: '2026-07-15T09:20:00', completed: true, certificateSentAt: '2026-07-28T16:00:00' },
      { id: 'enr-102', firstName: 'Riccardo', lastName: 'De Luca', email: 'r.deluca@hotmail.it', enrolledAt: '2026-09-10', price: 59, credentialsSentAt: '2026-09-10T14:45:00', completed: false },
      { id: 'enr-103', firstName: 'Elisa', lastName: 'Fontana', email: 'elisa.fontana@gmail.com', enrolledAt: '2026-09-30', price: 59, completed: false },
    ],
  },
]
